import React from "react"
import styled from "@emotion/styled"
import PropTypes from "prop-types"
import NextReadersArchiveImage from "./images/next-readers-archive-image"
import OpenWindowIcon from "./open-window-icon"
import parse from "html-react-parser"
const Container = styled.div`
  text-align: center;
  width: 100%;
  padding: 10px;
`
const Card = styled.div`
  position: relative;
  background-color: #ffffff;
  height: 100%;
  padding: 12px;
  border-radius: 5px;
`

const Image = styled.div`
  padding: 10px;
`
const Name = styled.div`
  // 15px
  font-size: 0.9375rem;
  margin-bottom: 8px;
`
const Title = styled.div`
  // 10px
  font-size: 0.625rem;
  transform: scale(0.8);
`
const FloatingOpenWindowIcon = styled.div`
  position: absolute;
  top: 5px;
  right: 8px;
`

const InterviewLink = styled.a`
  text-decoration: none;
  color: #000000;
`

const ReaderCard = ({ name, title, photo, post_url }) => (
  <Container>
    <InterviewLink href={post_url} target="_blank">
      <Card>
        <FloatingOpenWindowIcon>
          <OpenWindowIcon></OpenWindowIcon>
        </FloatingOpenWindowIcon>
        <Image>
          <NextReadersArchiveImage fileName={photo}></NextReadersArchiveImage>
        </Image>
        <Name>{parse(name)}</Name>
        <Title>{parse(title)}</Title>
      </Card>
    </InterviewLink>
  </Container>
)

ReaderCard.defaultProps = {
  name: "テスト",
}
ReaderCard.propTypes = {
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  photo: PropTypes.string.isRequired,
  post_url: PropTypes.string.isRequired,
}

export default ReaderCard
